export default "__VITE_ASSET__DhbSxxYU__"